"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWithCreate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const tech_1 = require("../../../tech");
const FormProvider_1 = require("../FormProvider");
const Alerts_1 = require("../../../tech/Alerts");
const react_ui_1 = require("@pasport/react-ui");
const FormWithCreate = ({ initValues, dispatchCreate, onCreateSuccess, children, fullWidth = false, bottomButton = false, buttonLabel }) => {
    const { fetchApiState: createFetch, apiState: createApiState } = (0, tech_1.useApiState)();
    const { addErrorAlert } = (0, Alerts_1.useAlert)();
    const handleCreateRequest = (props) => {
        createFetch(() => dispatchCreate(props));
    };
    (0, tech_1.useApiStateSuccess)(() => {
        if (onCreateSuccess && createApiState.data !== null)
            onCreateSuccess(createApiState.data);
    }, [createApiState]);
    (0, tech_1.useApiStateError)(() => {
        addErrorAlert({ message: 'Objevila se neočekávaná chyba. Zkuste akci zopakovat později.' });
    }, [createApiState]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(FormProvider_1.FormProvider, { defaultValues: initValues, onSubmit: handleCreateRequest, children: form => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!bottomButton && (0, jsx_runtime_1.jsx)(react_ui_1.CreateFormHeader, { onCreatePress: form.submit, isCreating: createApiState.loading, label: buttonLabel, fullWidth: fullWidth }), children(), bottomButton &&
                        (0, jsx_runtime_1.jsx)(react_ui_1.CreateFormHeader, { onCreatePress: form.submit, isCreating: createApiState.loading, label: buttonLabel, fullWidth: fullWidth })] })) }) }));
};
exports.FormWithCreate = FormWithCreate;
